module.exports = __webpack_public_path__ + "static/PFM02-dfca0bd99538999dfd74576dce13b234.jpg";